import * as _ from 'lodash-es'
import moment from 'moment'
import Notify from 'notifyjs'

/*
 * Desktop notifications for the resources the user is watching.
 *
 * Was an Angular factory taking `$timeout` and `localStorageService` (step 32 of #614).
 *
 * `$timeout` was only ever used to defer by a tick after the browser prompts for permission, so it
 * is `setTimeout`. The storage calls keep `angular-local-storage`'s behaviour exactly - the `ls.`
 * prefix and JSON encoding - so a browser that already has `ls.notifiableResources` keeps the
 * resources it had chosen. Writing the bare key instead would silently reset everyone's choices.
 */
const NOTIFIABLE_KEY = 'ls.notifiableResources'

function getNotifiableResources() {
  try {
    return JSON.parse(localStorage.getItem(NOTIFIABLE_KEY)) || []
  } catch {
    // Not JSON, so not something this wrote. Start over rather than failing a notification.
    return []
  }
}

function setNotifiableResources(resources) {
  localStorage.setItem(NOTIFIABLE_KEY, JSON.stringify(resources))

  return resources
}

function onShowNotification() {
  new Audio('audio/definite.mp3').play()
}

function onCloseNotification() {
  console.log('notification is closed!')
}

function onClickNotification() {
  window.focus()
  console.log('notification was clicked!')
}

function onErrorNotification() {
  console.error('Error showing notification. You may need to request permission.')
}

function onPermissionDenied() {
  console.warn('Permission has been denied by the user')
}

function notificationsEnabled() {
  return !Notify.needsPermission
}

function notify(id, title, body) {
  function showNotification() {
    console.log(id, title, body)
    // TODO: Play sound here
    new Notify(title, {
      body: body,
      tag: id,
      icon: 'images/hourglass-profile-no-text.png',
      requireInteraction: true,
      notifyShow: onShowNotification,
      notifyClose: onCloseNotification,
      notifyClick: onClickNotification,
      notifyError: onErrorNotification,
      timeout: 15,
    }).show()
  }

  if (!notificationsEnabled()) {
    Notify.requestPermission(() => {
      setTimeout(showNotification, 0)
    }, onPermissionDenied)
    return
  }

  showNotification()
}

function notifyBooking(booking) {
  const time = moment(booking.startsAt, 'DD-MM-YYYY HH:mm')
  const resource = booking.resource.name
  notify(booking._id, booking.description, time.format('h:mma') + ' ' + resource)
}

function notificationsConfigured(resourceName) {
  return _.some(getNotifiableResources(), function (filteredResource) {
    return resourceName == filteredResource
  })
}

function toggleNotifications(resourceName) {
  var notifiableResources = getNotifiableResources()
  var doesReceive = notificationsConfigured(resourceName)

  if (!doesReceive) {
    notifiableResources.push(resourceName)
  } else {
    notifiableResources = _.filter(notifiableResources, function (filteredResource) {
      return resourceName != filteredResource
    })
  }

  setNotifiableResources(notifiableResources)

  return !doesReceive
}

const notificationService = {
  notify: notify,
  notifyBooking: notifyBooking,
  notificationsEnabled: notificationsEnabled,

  getNotifiableResources: getNotifiableResources,
  setNotifiableResources: setNotifiableResources,

  notificationsConfigured: notificationsConfigured,
  toggleNotifications: toggleNotifications,
}

export default notificationService
